export const IDTRequests = Object.freeze({
    "DISPLAY_MODE": "display mode",
    "AUTHENTICATION": "authentication info",
    "LOAD_PROCESS": "load process",
    "CREATE_PROCESS":"create process",
    "DEFAULT_PROCESS": "default process",
    "LOAD_TREE_END": "load tree end",
    "LOAD_PLACEHOLDER_VALUES": "load placeholder values",
    "LOAD_PROCESS_TYPES": "load process types",
    "ERROR": "error",
    "LOAD_TREE_START": "load tree start",
    "LOAD_ENTITY_PARAMETERS": "load entity parameters",
    "LOAD_API_RESPONSE": "load api response"
    })

export const IDTResponses = Object.freeze({
        "LOADING": "loading",
        "ATTACH_PROCESS": "attach process",
        "UPDATE_PROCESS": "update process",
        "UPDATE_PLACEHOLDER_VALUE": "update placeholder value",
        "UPDATE_PLACEHOLDER_VALUE_LIST": "update placeholder value list",
        "CLOSE_PROCESS": "close process",
        "LINK_PROCESS": "link process",
        "RETURN_TO_PARENT_PROCESS": "return to parent process",
        "OPEN_PROCESS": "open process",
        "NAVIGATE_TO": "navigate to",
        "SEND_API_REQUEST": "send api request"
    })